import axios, { type AxiosRequestConfig } from 'axios';
import { mapKeys } from 'lodash';

import type { File as SineFile } from '../helpers/upload.types';
import { FileNameExceedsMaxLengthError } from './fileValidationErrors';

export type OnUploadProgressFn = AxiosRequestConfig<FormData>['onUploadProgress'];

// TODO: Export core-api `File` type and fix return type
export function uploadFile<T = SineFile>(
  url: string,
  file: Blob,
  params: Record<string, any> = {},
  onUploadProgress: OnUploadProgressFn = () => {},
  fileName: string,
) {
  // Only validate the file name if it is provided
  if (fileName && fileName.length > 100) {
    return Promise.reject(new FileNameExceedsMaxLengthError());
  }

  const formData = new FormData();
  formData.append('file', file, fileName);

  mapKeys(params, (value, key) => {
    formData.append(key, value);
  });

  return axios.post<T>(url, formData, { onUploadProgress });
}
